import { TRITECNICA_BORDER_RADIUS, TRITECNICA_BOX_SHADOW, TRITECNICA_COLORS, TRITECNICA_FONTS, TRITECNICA_SPACING, } from '../tritecnicaThemeConf';
export const tritecnicaNotificationsStyle = {
    Containers: {
        DefaultStyle: {
            width: 500,
            top: 'auto',
            bottom: 0,
            margin: '0 auto 0 -250px',
            left: '50%',
        },
    },
    NotificationItem: {
        DefaultStyle: {
            width: 500,
            minHeight: 60,
            height: 'auto',
            border: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '5.5em',
            borderRadius: TRITECNICA_BORDER_RADIUS.default,
            boxShadow: TRITECNICA_BOX_SHADOW.default,
        },
        success: {
            backgroundColor: TRITECNICA_COLORS.success.main,
        },
        info: {
            backgroundColor: TRITECNICA_COLORS.brand.main,
        },
        error: {
            backgroundColor: TRITECNICA_COLORS.error.main,
        },
        warning: {
            backgroundColor: TRITECNICA_COLORS.warning.main,
        },
    },
    Dismiss: {
        DefaultStyle: {
            display: 'none',
        },
    },
    Title: {
        DefaultStyle: {
            color: TRITECNICA_COLORS.font.light,
            fontSize: TRITECNICA_FONTS.size.mediumBig,
            fontWeight: TRITECNICA_FONTS.weight.bold,
            height: TRITECNICA_FONTS.size.mediumBig,
            marginBottom: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    MessageWrapper: {
        DefaultStyle: {
            minHeight: 20,
            fontSize: TRITECNICA_FONTS.size.medium,
            fontWeight: TRITECNICA_FONTS.weight.normal,
            lineHeight: 1.67,
            textAlign: 'left',
            color: TRITECNICA_COLORS.font.light,
            marginTop: TRITECNICA_SPACING.margin.smallest,
        },
    },
};
//# sourceMappingURL=tritecnicaNotificationsStyle.js.map